<template>
    <div class="automation-block-editor number-formatter">
        <div class="d-flex justify-content-between">
            <CustomPicker v-model="clone.mode" :items="formatTypes" idKey="id" labelKey="label" title="Select Format" />
            <SupsisButton @click="deleteFormatter" danger v-if="deleteEnabled" xxsmall>
                <i class="material-icons">delete</i>
            </SupsisButton>
        </div>

        <RandomNumber v-if="clone.mode === 'math.random'" v-model="clone" />
        <template v-else>
            <div class="editor-row customize-editor-minimize data-items">
                <div class="editor-row-title">Inputs</div>

                <div v-for="(item, index) in clone.values" :key="index" class="d-flex gap-5">
                    <TiptapEditor
                        placeholder="Input Text"
                        :show-attributes="true"
                        v-model="clone.values[index]"
                        :show-emoji="false"
                        automation-mode
                    />
                    <a @click="() => deleteInput(index)" :disabled="clone.values.length <= 1"> sil </a>
                </div>
            </div>
            <div class="d-flex flex-end w-100">
                <SupsisButton @click="addInput" v-if="!singleValueFormats.includes(clone.mode)" primary>
                    <i class="material-icons">add</i>
                    <span>Add Input</span>
                </SupsisButton>
            </div>
        </template>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../../components/pickers/CustomPicker.vue";
import SupsisButton from "../../../../../../Settings/components/SupsisButton.vue";
import DataItem from "../../webhook/DataItem.vue";
import RandomNumber from "./RandomNumber.vue";

const log = log2("NumberFormatter");
export default {
    name: "NumberFormatter",
    components: { RandomNumber, DataItem, SupsisButton, CustomPicker, TiptapEditor },
    props: ["value", "deleteEnabled"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "math.add",
            values: [""],
        };
        return {
            clone,
            singleValueFormats: ["math.abs", "math.ceil", "math.floor", "math.round"],
            formatTypes: [
                { id: "math.add", label: "Sum Numbers", description: "Sum all numbers" },
                { id: "math.sub", label: "Subtract Numbers", description: "Subtract all numbers" },
                { id: "math.mul", label: "Multiply Numbers", description: "Multiply all numbers" },
                { id: "math.div", label: "Divide Numbers", description: "Divide all numbers" },
                { id: "math.abs", label: "Absolute Value", description: "Get the absolute value of a number" },
                { id: "math.ceil", label: "Ceil", description: "Round a number upward to its nearest integer" },
                { id: "math.floor", label: "Floor", description: "Round a number downward to its nearest integer" },
                { id: "math.round", label: "Round", description: "Round a number to the nearest integer" },
                { id: "math.max", label: "Max", description: "Get the largest number" },
                { id: "math.min", label: "Min", description: "Get the smallest number" },
                { id: "math.avg", label: "Average", description: "Get the average of numbers" },
                { id: "math.mean", label: "Mean", description: "Get the mean of numbers" },
                { id: "math.increment", label: "Increment +1", description: "Increment a number by 1" },
                { id: "math.decrement", label: "Decrement -1", description: "Decrement a number by 1" },
                { id: "math.random", label: "Random Number", description: "Random Number" },
            ],
        };
    },
    methods: {
        addInput() {
            this.clone.values.push("");
        },
        deleteInput(index) {
            this.clone.values.splice(index, 1);
        },
        deleteFormatter() {
            this.$emit("delete");
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                const modeChanged = newValue.mode !== oldValue.mode;
                const isSingleValueFormat = this.singleValueFormats.includes(newValue.mode);
                if (modeChanged && isSingleValueFormat) {
                    this.clone.values = [newValue.values[0]];
                    newValue.values = [newValue.values[0]];
                }
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.number-formatter {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
